import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component(
{
    selector: 'app-warned',
    template: 'warning',
    styleUrls: ['./warned.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarnedComponent
{
    @HostBinding('class.material-icons') private readonly materialIcons = true;
}
